import { render, staticRenderFns } from "./View.vue?vue&type=template&id=825a426e&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('825a426e')) {
      api.createRecord('825a426e', component.options)
    } else {
      api.reload('825a426e', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=825a426e&", function () {
      api.rerender('825a426e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/View.vue"
export default component.exports